<template>
    <footer class="footer">
        <div class="footerTop">
            <div class="auto">
                <!-- 站內連結 -->
                <div class="item link">
                    <div class="title">站內連結</div>
                    <router-link class="content" to="/">首頁</router-link>
                    <router-link class="content" to="/order">線上訂車</router-link>
                    <router-link class="content" to="/qa">常見問題</router-link>
                    <router-link class="content" to="/track">訂單查詢</router-link>
                    <router-link class="content" to="/suggest">評價司機</router-link>
                </div>
                <!-- 服務項目 -->
                <div class="item service">
                    <div class="title">服務項目</div>
                    <div class="content">接送服務</div>
                    <div class="content">包車旅遊服務</div>
                    <div class="content">結婚禮車</div>
                    <div class="content">企業商務包車</div>
                    <div class="content">婚紗寫真外拍包車</div>
                    <div class="content">活動包車(戶外活動)</div>
                </div>
                <!-- 關注我們 -->
                <div class="item follow">
                    <div class="title">關注我們</div>
                    <div class="icon">
                        <a href="https://www.facebook.com/sttcttt/" target="_blank">
                            <img src="./img/fb.png" alt="fb" />
                        </a>
                        <a href="https://www.instagram.com/smiletotravel/" target="_blank">
                            <img src="./img/Instagram.png" alt="instagram" />
                        </a>
                    </div>
                    <img class="line" src="./img/line.jpg" alt="line" />
                </div>
                <!-- LOGO -->
                <div class="item logo">
                    <img src="./img/logo.png" alt="logo" />
                </div>
            </div>
        </div>
        <div class="footerBottom">
            <div
                class="auto"
            >客服時間:24HR | Line客服ID:samile333 | 客服專線:0905-190571 | smiletotravel.com All Rights Reserved.</div>
        </div>
    </footer>
</template>
<script>
export default {
    name: 'footerBar'
};
</script>
<style lang="scss" scoped>
a {
    color: white;
    display: block;
}
.footer {
    font-family: '微軟正黑體', sans-serif;
    color: white;
    // 上面的footer
    .footerTop {
        background-color: $deep-green;
        padding: 48px 0;
        .auto {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            width: 1440px;
            margin: auto;
            @media screen and (max-width: 1440px) {
                width: 1224px;
            }
            @media screen and (max-width: 1224px) {
                width: 96%;
            }
            // 所有項目
            .item {
                margin: 0 0 16px 0;
                .title {
                    font-size: 24px;
                    padding: 0 0 0 16px;
                    margin: 0 0 8px 0;
                    position: relative;
                    font-weight: 700;
                    &:before {
                        content: '';
                        position: absolute;
                        width: 4px;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        margin: auto;
                        background-color: white;
                    }
                }
                .content {
                    font-size: 16px;
                    line-height: 32px;
                    font-weight: 700;
                }
                a:hover {
                    text-decoration: underline;
                }
            }
            // 服務項目
            .service {
                .content:before {
                    content: '- ';
                }
            }
            // 關注我們
            .follow {
                .icon {
                    display: flex;
                    a {
                        transition: 0.7s;
                        margin: 0 16px 8px 0;
                        img {
                            width: 48px;
                            height: 48px;
                        }
                        &:hover {
                            opacity: 0.7;
                        }
                    }
                }
                .line {
                    width: 160px;
                    height: 160px;
                }
            }
            // logo
            .logo {
                img {
                    height: 200px;
                }
            }
        }
    }
    // 下面的footer
    .footerBottom {
        background-color: $green;
        .auto {
            width: 1440px;
            margin: auto;
            letter-spacing: 1px;
            font-size: 12px;
            line-height: 48px;
            text-align: center;
            @media screen and (max-width: 1440px) {
                width: 1224px;
            }
            @media screen and (max-width: 1224px) {
                width: 96%;
            }
        }
    }
}
</style>
